module.exports = __webpack_public_path__ + "static/media/_MIC2551.image.28fbe102.png";